import { QueryHookOptions, useQuery } from '@apollo/client';

import { GET_FORM_BY_CHILD_ID } from './queries';
import type { Evaluation } from './types';

export const useFormByChildId = (options?: QueryHookOptions) =>
  useQuery<{
    evaluations: Evaluation[];
  }>(GET_FORM_BY_CHILD_ID, options);
